import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { delay, motion } from "motion/react";
import { duration } from "@mui/material";

// import Form from "./Form";
const Modal = ({ modal, setModal }) => {
  const values = [
    {
      title: "Dangerous Goods (DGR Cargo)",
      img: null,
      text: `  <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">Saharawinds Ltd DGR Standard Operating Procedure</h3>
      <p className="text-sm mb-4">
        Saharawinds Ltd’s DGR standard operating procedure ensures the safe and compliant transportation of hazardous (DGR) shipments. Preparing dangerous goods (DGR) shipments involves several critical steps to ensure compliance with international safety standards and IATA regulations. Saharawinds will guide shippers through the process by:
      </p>
      <h4 className="text-md font-semibold mb-2">1. Classification</h4>
      <p className="text-sm mb-4">
        Saharawinds DGR experts will identify and classify the dangerous goods according to the International Air Transport Association (IATA) Dangerous Goods Regulations (DGR). This involves determining the UN number, proper shipping name, hazard class, and packing group.
      </p>
      <h4 className="text-md font-semibold mb-2">2. Packaging</h4>
      <p className="text-sm mb-4">
        Saharawinds DGR experts will ensure only appropriate packaging that is compliant with IATA DGR. The packaging will be appropriate for the type of dangerous goods being shipped and must meet all regulatory requirements.
      </p>
      <h4 className="text-md font-semibold mb-2">3. Marking and Labelling</h4>
      <p className="text-sm mb-4">
        Saharawinds DGR experts will properly mark and label each package with the correct hazard labels, handling labels, and any other required markings. This includes the UN number, proper shipping name, and hazard class.
      </p>
      <h4 className="text-md font-semibold mb-2">4. Documentation</h4>
      <p className="text-sm mb-4">
        Saharawinds DGR experts will complete the Shipper’s Declaration for Dangerous Goods and the Air Waybill. The declaration must include detailed information about the shipment, including the shipper’s and recipient’s details, the nature and quantity of the dangerous goods, and any special handling instructions.
      </p>
      <h4 className="text-md font-semibold mb-2">5. Inspection and Verification</h4>
      <p className="text-sm mb-4">
        Before shipping, Saharawinds DGR experts will inspect the packages to ensure they are correctly packed, marked, labelled, and documented. They will verify that all information is accurate and that the shipment complies with IATA and specific airline DGR regulations.
      </p>
      <p className="text-sm">
        If you need more detailed guidance on shipping DGR shipments, consult Saharawinds Ltd.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>
    </section>
  </div>`,
    },
    {
      title: "Pharma & Healthcare",
      img: null,
      text: `<div className="p-6 space-y-6">
  <section>
    <h3 className="text-lg font-bold mb-4">Pharma & Healthcare Logistics</h3>
    <p className="text-sm mb-4">
      At Saharawinds Ltd, we leverage state-of-the-art temperature-controlled logistics to ensure the safe and timely 
      delivery of critical healthcare shipments. Our services include the transport of vaccines, biological samples, 
      and medical products, all of which are vital to saving lives.
    </p>
    
    <h4 className="text-md font-semibold mb-2">Our Commitment to Excellence</h4>
    <ul className="list-disc pl-6 text-sm mb-4 space-y-2">
      <li>
        <span className="font-bold">Temperature-Controlled Logistics:</span> We utilize advanced temperature-controlled systems to 
        maintain the integrity of sensitive healthcare shipments throughout the entire transit.
      </li>
      <li>
        <span className="font-bold">Timely Delivery:</span> Our efficient logistics network ensures that all healthcare shipments 
        are delivered on time, meeting the urgent needs of the healthcare industry.
      </li>
    </ul>

    <h4 className="text-md font-semibold mb-2">Regulatory Compliance</h4>
    <ul className="list-disc pl-6 text-sm mb-4 space-y-2">
      <li>
        <span className="font-bold">International Standards:</span> We comply with guidelines from organizations like the World 
        Health Organization (WHO) and the International Air Transport Association (IATA).
      </li>
      <li>
        <span className="font-bold">Local Regulations:</span> We adhere to the specific requirements of each country regarding 
        the import, storage, and distribution of medicines.
      </li>
    </ul>

    <h4 className="text-md font-semibold mb-2">Integrity and Safety</h4>
    <p className="text-sm mb-4">
      We are dedicated to maintaining the highest standards of safety and integrity for all healthcare shipments, ensuring 
      they arrive in perfect condition.
    </p>

    <p className="text-sm">
      <span className="font-bold">Why Choose Saharawinds Ltd?</span> With our expertise in temperature-controlled logistics, 
      you can trust Saharawinds Ltd to handle your critical healthcare shipments with the utmost care and precision.
    </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

  </section>
</div>
`,
    },
    {
      title: "Humanitarian Support Logistics",
      img: null,
      text: `  <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">Humanitarian Support Logistics: Delivering Hope, Fast</h3>
      <p className="text-sm mb-4">
        At Saharawinds Ltd, we expedite critical supplies, deliver urgent food aid, and transport life-saving disaster recovery materials to communities in distress. Our dedicated team is committed to overcoming logistical challenges and ensuring timely delivery, even in the most remote and devastated areas.
      </p>
      <h4 className="text-md font-semibold mb-2">Our Commitment to Humanitarian Support</h4>
      <p className="text-sm mb-4">
        Saharawinds understands the urgency and importance of delivering aid to those in need. Our team works tirelessly to ensure that essential supplies reach their destinations quickly and efficiently, providing much-needed relief and support.
      </p>
      <h4 className="text-md font-semibold mb-2">Why Partner with Saharawinds Ltd?</h4>
      <p className="text-sm mb-4">
        Partner with Saharawinds Ltd to deliver hope and support to those in need. Contact Saharawinds Ltd today to learn more about our humanitarian logistics solutions.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Machinery & Equipment",
      img: null,
      text: `<div className="p-6 space-y-8">
    <section>
      <h3 className="text-lg font-bold mb-6">Project Logistics</h3>
      <p className="text-sm mb-6">
        Saharawinds Ltd specializes in the transportation of heavy and intricate equipment critical to industries such as agriculture, manufacturing, mining, oil, and gas. Whether it’s oversized machinery or precision tools, we ensure safe and timely delivery, even to remote locations.
      </p>
      <p className="text-sm">
        The Saharawinds Ltd team ensures safety during the transportation of heavy and intricate equipment by implementing several key project logistics practices:
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Key Practices in Project Logistics</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Mapping & Planning:</strong> Saharawinds Ltd coordinates route planning to avoid obstacles and ensure the safest path.</li>
          <li className="text-sm"><strong>Specialized Equipment:</strong> The right mode of transport and tools designed for heavy loads and delicate machinery are chosen for the job.</li>
          <li className="text-sm"><strong>Expertise Personnel:</strong> Experienced team members are deployed, with knowledge of the nuances involved in transporting such equipment.</li>
          <li className="text-sm"><strong>Secure Packaging & Inspection:</strong> Equipment is inspected, secured, and packaged to prevent movement and damage during transit.</li>
        </ul>
      </div>
    </section>

    <section>
      <p className="text-sm mt-6">
        These measures help Saharawinds Ltd maintain high safety standards and ensure the safe delivery of equipment to even the most remote locations.
      </p>
      <p className="text-sm mt-4">
        Do you have any specific concerns regarding project logistics? Contact Saharawinds Ltd to manage your project logistics.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Time-critical Logistics",
      img: null,
      text: `   <div className="p-6 space-y-8">
    <section>
      <h3 className="text-lg font-bold mb-6">Saharawinds’ Time-critical Logistics</h3>
      <p className="text-sm mb-6">
        Saharawinds’ Time-critical Logistics service is designed for industries where timely delivery is crucial, such as aviation and marine operations.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Our Focus</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Urgent Deliveries:</strong> Ensuring that essential materials and spare parts are delivered promptly to minimize downtime.</li>
          <li className="text-sm"><strong>Streamlined Processes:</strong> Utilizing efficient procedures to expedite shipments.</li>
          <li className="text-sm"><strong>Dedicated Resources:</strong> Allocating specific resources to handle urgent deliveries.</li>
          <li className="text-sm"><strong>Commitment to Punctuality:</strong> Ensuring that shipments arrive exactly when and where they are needed.</li>
        </ul>
      </div>
    </section>

    <section>
      <p className="text-sm mt-6">
        This service is ideal for situations where every moment counts, helping to maintain seamless operations and reduce delays.
      </p>
      <p className="text-sm mt-4">
       Consult sahara winds ltd to manage your critical time shipment.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Saharawinds - Fashion & Textile Shipments",
      img: null,
      text: ` <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">
        Fashion and Textile Logistics
      </h3>
      <p className="text-sm mb-4">
        Our specialized logistics solutions are tailored to meet the unique demands of the dynamic fashion and textile industry. With a deep understanding of industry trends and challenges, we provide reliable and efficient delivery of garments, fabrics, and accessories. Our services cater to seasonal demands, ensuring timely delivery in line with fast-paced retail schedules. Our experienced team ensures timely and accurate shipments, even during peak seasons.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">Why Choose Saharawinds Ltd?</h4>
      <p className="text-sm">
        Contact Saharawinds Ltd today to discuss your specific needs and experience the difference of our expert fashion and textile logistics solutions.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Saharawinds - Live Animals & Live Seafood",
      img: null,
      text: ` <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">
        Welcome to Saharawinds Ltd – Your Trusted Partner in Live Animal Logistics
      </h3>
      <p className="text-sm mb-4">
        At Saharawinds Ltd, we specialize in providing top-notch live animal logistics solutions to ensure the safe and comfortable transport of your valuable pets. Our dedicated team takes several important steps to prepare live animals for transport, ensuring their safety and well-being throughout the transit.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">Our Comprehensive Live Animal Transport Services</h4>
      <ol className="list-decimal pl-5 space-y-2 text-sm">
        <li>
          <b>Live Animal Health Checks:</b> Veterinarians conduct thorough health examinations to ensure that all animals are free from diseases and injuries, making it safe for them to travel.
        </li>
        <li>
          <b>Live Animal Shipping Documentation:</b> Saharawinds handles all necessary permits, licenses, and health certificates to comply with live animal transport regulations, ensuring a smooth and hassle-free process.
        </li>
        <li>
          <b>Specialized Live Animal Shipping Containers:</b> Animals are placed in containers specifically designed for their species, providing adequate space, ventilation, and security to keep them comfortable and safe. We also allow time for acclimatization to reduce stress and anxiety. Saharawinds’ live animal team is on standby to advise the appropriate container.
        </li>
        <li>
          <b>Feeding and Hydration:</b> Saharawinds’ live animal team ensures that animals are fed and hydrated before the transit. For longer trips, we make provisions to ensure they have access to food and water during transit.
        </li>
        <li>
          <b>Monitoring:</b> Animals are regularly monitored throughout the transit to ensure their well-being. Any signs of distress or health issues are addressed promptly.
        </li>
      </ol>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">Why Choose Saharawinds Ltd?</h4>
      <p className="text-sm mb-4">
        Our key practices for shipping live animals help ensure that they arrive at their destination safely and in good health. Contact Saharawinds Ltd today to discuss your specific needs and receive expert guidance on shipping live animals safely and efficiently.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Kenyan Flowers",
      img: null,
      text: `<div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">Shipping Cut Flowers by Airfreight</h3>
      <p className="text-sm mb-4">
        Shipping cut flowers by airfreight involves several critical steps to ensure the flowers remain fresh and undamaged during transportation. Here’s how Saharawinds Ltd handles this process:
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">1. Cut Flowers Harvesting and Pre-Cooling</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm">Harvesting: Flowers are harvested at their peak freshness at the farms by experts to minimize damage.</li>
        <li className="text-sm">Pre-Cooling: Immediately after harvesting, flowers undergo pre-cooling to retain optimal freshness and preserve their quality.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">2. Cut Flowers Packaging</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm">Sorting and Packaging: Flowers are processed by type, size, and quality, then packaged in specially designed flower boxes that provide support and ventilation.</li>
        <li className="text-sm">Protection: Good packaging materials protect flowers from physical damage and temperature fluctuations.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">3. Cut Flowers Transportation to Airport</h4>
      <p className="text-sm">
        Refrigerated Transport: Flowers are transported from the farms to the airport by reefer trucks.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">4. Airport Handling and Cold-Room Warehousing</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm">Temperature-Controlled Storage: At the airport, flowers are stored in cold-rooms at optimal temperatures to preserve freshness and quality.</li>
        <li className="text-sm">Plant Health Inspection: Flower shipments must adhere to plant quarantine and phytosanitary regulations, Saharawinds will facilitate Phytosanitary inspection and declaration. Kenya Plant Health Inspectorate Services (KEPHIS) officials will inspect the shipment and issue a phytosanitary certificate.</li>
        <li className="text-sm">Export Documentation: Additional documents such as the Airway Bill (AWB), customs entry, preferential certificate of origin, and export certificate are processed and reviewed by respective authorities to ensure compliance with both Kenya export regulations and import regulations of the destination country.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">5. Consolidation</h4>
      <p className="text-sm">
        Flower consignments from multiple farms are consolidated into single shipments as specified by importers and shippers. Saharawinds acts as a sourcing agent for importers seeking to import flowers directly from different Kenyan flower farms. We consolidate consignments, process the necessary documents, and combine them into a single shipment, saving on costs.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">6. Air Freight</h4>
      <p className="text-sm">
        Cargo Build-Up: Flowers are loaded onto pallets (Unit Load Devices, ULDs) and secured with straps or netting to prevent movement during transit. The pallets are then transferred to airside for loading into the aircraft.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">7. Arrival and Distribution</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm">Unloading and Storage: On arrival, flowers are carefully unloaded and stored in temperature-controlled facilities at the destination airport by our destination partner.</li>
        <li className="text-sm">Customs Clearance: Shipment documentation is reviewed, and customs clearance is obtained to release the flower shipment to the consignee.</li>
      </ul>
    </section>

    <section>
      <p className="text-sm">
        Consult Saharawinds Ltd to plan your next flower shipment.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Fruits & Vegatables",
      img: null,
      text: `  <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">Shipping Fruits and Vegetables by Air and Ocean Freight</h3>
      <p className="text-sm mb-4">
        Shipping fruits and vegetables involves different processes for air and ocean freight to ensure the produce remains fresh and reaches its destination in optimal condition. Here’s how Saharawinds Ltd handles the process:
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">1. Air Freight</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm"><strong>Speed and Freshness:</strong> Air freight is ideal for highly perishable fruits and vegetables that need to reach their destination quickly. This method ensures minimal transit time, preserving the freshness and quality of the produce.</li>
        <li className="text-sm"><strong>Packaging:</strong> Produce is carefully packaged in ventilated boxes to allow for air circulation and prevent damage. Temperature-sensitive items are often packed with gel packs or dry ice.</li>
        <li className="text-sm"><strong>Temperature Control:</strong> Throughout the transit, from the farm to the aircraft and during the flight, the produce is kept in temperature-controlled environments to prevent spoilage.</li>
        <li className="text-sm"><strong>Handling and Storage:</strong> At the destination, the produce is quickly transferred to refrigerated storage facilities to maintain the cold chain until it reaches the market.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">2. Ocean Freight</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm"><strong>Cost-Effectiveness:</strong> Ocean freight is more economical for shipping large quantities of fruits and vegetables over long distances. It is suitable for produce with a longer shelf life.</li>
        <li className="text-sm"><strong>Refrigerated Containers:</strong> Also known as reefers, these containers are equipped with advanced refrigeration systems to maintain the required temperature and humidity levels throughout the voyage.</li>
        <li className="text-sm"><strong>Atmosphere Control:</strong> Technologies like Controlled Atmosphere (CA) and Modified Atmosphere Packaging (MAP) are used to extend the shelf life of the produce by controlling oxygen and carbon dioxide levels inside the containers.</li>
        <li className="text-sm"><strong>Monitoring:</strong> Continuous monitoring of temperature and humidity is conducted to ensure the produce remains in optimal condition. Any deviations are promptly addressed by the crew.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">3. Key Considerations</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm"><strong>Transit Time:</strong> Air freight is faster but more expensive, while ocean freight is slower but more cost-effective.</li>
        <li className="text-sm"><strong>Shelf Life:</strong> Highly perishable items like leafy greens are better suited for air freight, whereas hardier produce like cabbage and potatoes can be shipped by sea.</li>
      </ul>
    </section>

    <section>
      <p className="text-sm">
        Consult Saharawinds Ltd. to plan your next fruit and vegetable shipment.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Kenyan Avocado",
      img: null,
      text: `  <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">Shipping Avocados by Ocean Freight</h3>
      <p className="text-sm mb-4">
        Shipping avocados by ocean freight involves several specialized processes to ensure they arrive fresh and in optimal condition. Here’s how Saharawinds Ltd. manages avocado shipments:
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">1. Harvesting and Pre-Cooling</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm"><strong>Harvesting:</strong> Avocados are picked at the right maturity level to ensure consistent ripening.</li>
        <li className="text-sm"><strong>Pre-Cooling:</strong> Immediately after harvesting, avocados are delivered to cold rooms and pre-cooled to remove field heat and manage the ripening process.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">2. Packaging & Labelling</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm"><strong>Sorting and Packaging:</strong> At the packhouse, avocados are sorted by size and quality, then packed in ventilated boxes to allow air flow. The boxes are labelled with information such as avocado size, type, and country of origin.</li>
        <li className="text-sm"><strong>Protection:</strong> Packaging materials are used to protect the avocados from physical damage and preserve optimal quality.</li>
        <li className="text-sm"><strong>Plant Health Inspection and Procedures:</strong> Avocado shipments must adhere to Kenya and destination country plant quarantine and phytosanitary regulations. Saharawinds facilitates phytosanitary inspection and declaration. Kenya Plant Health Inspectorate Services (KEPHIS) officials inspect the shipment to ensure it meets the recommended standards and issue a phytosanitary certificate. Additional export documentation, including Airway Bill (AWB)/Bill of Lading (BL), customs entry, preferential certificate of origin, and export certificate, are prepared and reviewed to ensure compliance with both Kenya export regulations and the import regulations of the destination country.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">3. Refrigerated Containers (Reefers)</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm"><strong>Loading:</strong> Avocado boxes are placed on treated wooden pallets and securely strapped. These pallets are then loaded into reefer containers ready for delivery to the shipping line.</li>
        <li className="text-sm"><strong>Controlled Atmosphere Technology:</strong> Saharawinds recommends use of reefer sea containers with Controlled Atmosphere technology, which regulates oxygen, carbon dioxide, and ethylene levels to extend shelf life during the voyage.</li>
        <li className="text-sm"><strong>Temperature Control:</strong> The reefer containers maintain optimal temperature to preserve the quality of the avocados.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">4. Arrival and Distribution</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm"><strong>Unloading and Storage:</strong> Upon arrival, avocados are carefully unloaded and stored in temperature-controlled facilities.</li>
        <li className="text-sm"><strong>Customs Import Clearance:</strong> Proper documentation and customs import clearance are handled to ensure smooth entry into the destination market.</li>
      </ul>
    </section>

    <section>
      <p className="text-sm">
        Consult Saharawinds Ltd for expert handling of your avocado shipments from Kenya.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Goat & Lamp Meat",
      img: null,
      text: `  <div className="p-6 space-y-8">
    <section>
      <h3 className="text-lg font-bold mb-6">Chilled & Frozen Meat Shipping Services</h3>
      <p className="text-sm mb-6">
        Saharawinds Ltd offers reliable door-to-door shipping of chilled and frozen meat, including goat, lamb, and beef, from Kenya to the Middle East countries of Bahrain, Iraq, Oman, Qatar, Saudi Arabia, and UAE. With years of experience and deep expertise shipping meat, Saharawinds ensures that your meat shipment is delivered on schedule under the best food safety standards.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Our Process</h4>

      <div className="space-y-4">
        <h5 className="text-md font-semibold mb-4">1. Harvesting and Initial Processing</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Slaughter and Processing:</strong> We source healthy livestock, which are examined by Kenya government veterinary officials and processed in approved export slaughterhouses under strict hygienic conditions.</li>
          <li className="text-sm"><strong>Pre-cooling:</strong> Freshly processed meat is chilled to optimal temperatures for over 8 hours to ensure proper cooling and meat quality.</li>
        </ul>

        <h5 className="text-md font-semibold mb-4">2. Packaging</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Preparation:</strong> Meat is dressed in mutton cloth to prevent contamination.</li>
          <li className="text-sm"><strong>Labeling:</strong> Each carcass is labeled with essential information, including type of meat, weight, date of slaughter, and expiration date.</li>
        </ul>

        <h5 className="text-md font-semibold mb-4">3. Temperature Control</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Chilled Meat:</strong> Stored at temperatures between 0°C and 4°C to maintain freshness.</li>
          <li className="text-sm"><strong>Frozen Meat:</strong> Stored at temperatures at or below -18°C to ensure it remains frozen solid.</li>
        </ul>

        <h5 className="text-md font-semibold mb-4">4. Transportation</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Refrigerated Trucks (Reefers):</strong> Used for both chilled and frozen meat, maintaining optimal temperatures throughout the transit.</li>
          <li className="text-sm"><strong>Ocean Freight:</strong> We recommend using refrigerated sea containers with Controlled Atmosphere technology for sea shipments.</li>
        </ul>

        <h5 className="text-md font-semibold mb-4">5. Monitoring and Compliance</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Food Safety & Animal Health Inspections:</strong> Our shipments comply with Kenya and destination country regulations. The Kenya government veterinary services issue an export veterinary certificate, and we prepare all necessary export documentation, including Airway Bill (AWB)/Bill of Lading (BL), customs entry, preferential certificate of origin, export certificate, and Halal certificate.</li>
        </ul>

        <h5 className="text-md font-semibold mb-4">6. Arrival and Distribution</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Unloading and Storage:</strong> Upon arrival, meat is transferred to temperature-controlled storage facilities.</li>
          <li className="text-sm"><strong>Distribution:</strong> Efficient logistics ensure that the meat reaches its final destination quickly and in optimal condition.</li>
        </ul>
      </div>
    </section>

    <section>
      <p className="text-sm mt-6">
        Consult Saharawinds Ltd for expert handling of your meat shipments from Kenya.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Air Freight Solutions",
      img: null,
      text: `  <div className="p-6 space-y-8">
    <section>
      <h3 className="text-lg font-bold mb-6">Saharawinds Air Freight</h3>
      <p className="text-sm mb-6">
        Swift, Secure, Specialized: Your Air Cargo Solution
      </p>
      <p className="text-sm mb-6">
        Saharawinds offers reliable and efficient air cargo solutions tailored to your specific needs. Our strategic partnerships with major airlines ensure dedicated capacity for your shipments, guaranteeing timely departures and deliveries.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Key Benefits</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Guaranteed Capacity:</strong> Saharawinds Ltd facilitates block space agreements for reliable and guaranteed cargo capacity allocation.</li>
          <li className="text-sm"><strong>Global Reach, Local Expertise:</strong> Saharawinds' extensive network of international partners ensures seamless air freight for your shipments to global markets. Our strategic partnerships ensure seamless and efficient delivery to key destinations.</li>
          <li className="text-sm"><strong>Time-Sensitive Delivery:</strong> Expedited shipping for urgent and high-value air cargo shipments.</li>
          <li className="text-sm"><strong>Door-to-Door Logistic Solutions:</strong> Saharawinds Ltd is your trusted supply chain partner for seamless and efficient air cargo door-to-door solutions. We offer a comprehensive range of air freight services to manage your shipments from origin to destination, ensuring a smooth and hassle-free air freight logistics experience.</li>
          <li className="text-sm"><strong>Navigating the Complexities of International Trade:</strong> At Saharawinds, we understand the challenges of navigating the complex landscape of international trade. Our in-depth knowledge of preferential trade agreements, import and export customs regulations, combined with our commitment to regulatory compliance, ensures efficient air freight logistics to minimize supply chain risks and disruptions.</li>
          <li className="text-sm"><strong>Expert Customs Clearance:</strong> Expertise in navigating complex customs procedures, ensuring compliance to minimize delays for your air cargo shipments.</li>
          <li className="text-sm"><strong>Advanced Tracking:</strong> Real-time visibility of your air freight shipments.</li>
          <li className="text-sm"><strong>Competitive Pricing:</strong> Cost-effective air cargo solutions without compromising quality.</li>
        </ul>
      </div>
    </section>

    <section>
      <p className="text-sm mt-6">
        Contact Saharawinds Ltd to deliver your air freight cargo with precision and care.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Sea Freight Solutions",
      img: null,
      text: `<div className="p-6 space-y-8">
    <section>
      <h3 className="text-lg font-bold mb-6">Saharawinds Ocean Freight Solutions</h3>
      <p className="text-sm mb-6">
        Seamless Global Shipping, Cost-Effective Solutions
      </p>
      <p className="text-sm mb-6">
        Saharawinds offers reliable and efficient ocean freight solutions to meet your global shipping needs. Our partnerships with leading ocean shipping lines ensure dependable and cost-effective transportation of your cargo.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Our Ocean Freight Services:</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Full Container Load (FCL):</strong> Dedicated container for one shipper.</li>
          <li className="text-sm"><strong>Less Than Container Load (LCL):</strong> Consolidating smaller shipments for cost-efficiency.</li>
          <li className="text-sm"><strong>Break Bulk:</strong> Saharawinds Ltd specializes in handling break bulk cargo, ensuring efficient shipping of oversized or irregular-shaped items that demand specialized expertise.</li>
          <li className="text-sm"><strong>Project Cargo:</strong> Saharawinds Ltd is equipped to expertly handle complex and large-scale project cargo, offering tailored ocean freight solutions designed to meet the unique demands of intricate and challenging shipments.</li>
        </ul>
      </div>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Why Choose Saharawinds?</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Global Network:</strong> Access to a vast network of ocean shipping lines and partner agents worldwide.</li>
          <li className="text-sm"><strong>Seamless Logistics:</strong> Door-to-door ocean freight solutions to manage shipments from origin to destination.</li>
          <li className="text-sm"><strong>Cost-Effective Solutions:</strong> Optimized shipping routes and competitive rates.</li>
          <li className="text-sm"><strong>Expert Customs Clearance:</strong> Smooth customs procedures and regulatory compliance.</li>
          <li className="text-sm"><strong>Risk Management:</strong> Proactive measures to mitigate potential supply chain risks and disruptions.</li>
        </ul>
      </div>
    </section>

    <section>
      <p className="text-sm mt-6">
        Consult Saharawinds Ltd to manage your ocean freight shipping requirements.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Charter Air Freight Services",
      img: null,
      text: `  <div className="p-6 space-y-8">
    <section>
      <h3 className="text-lg font-bold mb-6">Saharawinds Charter Services</h3>
      <p className="text-sm mb-6">
        Urgent Deliveries, Swift Solutions
      </p>
      <p className="text-sm mb-6">
        Saharawinds: Your Partner for Time-Critical Shipments
      </p>
      <p className="text-sm mb-6">
        When time is of the essence, trust Saharawinds charter services. We offer dedicated air transport charter solutions tailored to your specific needs, ensuring your urgent shipments are delivered to their destination on schedule. Saharawinds' team of experts will work closely with the shipper to plan and execute the charter flight, providing end-to-end support from flight cordination, flight operation to delivery.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Key Benefits:</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Dedicated Aircraft:</strong> Exclusive use of an aircraft for your shipment, ensuring faster transit times and avoiding potential delays.</li>
          <li className="text-sm"><strong>Direct Routes:</strong> Optimized flight paths to minimize transit time and reduce costs.</li>
          <li className="text-sm"><strong>Customized Schedules:</strong> Flexible scheduling to accommodate specific needs and deadlines.</li>
          <li className="text-sm"><strong>Priority Handling:</strong> Saharawinds team will expedite handling throughout the logistics process, from customs clearance, cargo build-up & palletization, aircraft loading to delivery of cargo.</li>
          <li className="text-sm"><strong>Experienced Team:</strong> Saharawinds Ltd team of experts will guide you through the entire charter process, ensuring a smooth and efficient experience.</li>
        </ul>
      </div>
    </section>

    <section>
      <p className="text-sm mt-6">
        Don't let delays impact your business. Consult Saharawinds Ltd to discuss your time-critical logistics requirements.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Customs Clearance",
      img: null,
      text: `  <div className="p-6 space-y-8">
    <section>
      <h3 className="text-lg font-bold mb-6">Saharawinds - Customs Clearance</h3>
      <p className="text-sm mb-6">
        Navigating the Complexities of Cross Border Trade
      </p>
      <p className="text-sm mb-6">
        At Saharawinds Ltd, we understand the complexities of navigating cross-border trade. Leveraging our in-depth knowledge of import and export regulations, we guide exporters and importers through every step of the customs clearance process, ensuring smooth trade flows and optimized costs. Saharawinds provides comprehensive support from document preparation and declaration to post-clearance formalities, expert advisory services on regulatory compliance, and preferential trade agreements. Our expertise ensures seamless logistics solutions that keep your supply chain efficient and compliant.
      </p>
      <p className="text-sm mb-6">
        We offer a comprehensive range of customs clearance services to streamline your imports and exports.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Import Clearance:</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Pre-shipment inspections and verification:</strong> Rigorous checks to ensure quality and compliance with import standards.</li>
          <li className="text-sm"><strong>Customs documentation preparation and submission to Kenya Revenue Authority (KRA) and Kentrade:</strong> Accurate and timely preparation of all required customs documents, including import declarations, invoices, packing lists, and certificates of origin.</li>
          <li className="text-sm"><strong>Customs valuation and classification:</strong> Saharawinds customs team will ensure accurate classification of goods with the right customs tariff code to minimize import duties and taxes. Customs clearance verification and audit: Saharawinds ensures verifying the accuracy of customs declarations and ensuring compliance with customs regulations. Our team will efficiently handle the customs clearance procedures, customs examination & inspection to ensure timely release of shipments.</li>
        </ul>
      </div>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Export Clearance:</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Export license and permit procurement:</strong> Assisting clients in obtaining necessary export licenses and permits, preferential trade agreement (PTA) certification.</li>
          <li className="text-sm"><strong>Export documentation preparation and declaration to Kenya Revenue Authority and Kentrade:</strong> Accurate and timely preparation of export declarations, invoices, packing lists, and certificates of origin.</li>
          <li className="text-sm"><strong>Post-shipment formalities:</strong> Handling post-shipment formalities, such as providing shipping documents to the shipper.</li>
        </ul>
      </div>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Regulatory Compliance:</h4>
      <div className="space-y-4">
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm"><strong>Build Strong Relationships with Customs Authorities:</strong> Saharawinds Ltd has established positive working relationships with customs authorities to facilitate smooth customs clearance and address customs compliance issues promptly. We continuously monitor changes in customs regulations and trade policies to ensure our services are always compliant.</li>
          <li className="text-sm"><strong>Advising clients on import and export restrictions and prohibitions:</strong> We provide expert guidance on import and export restrictions, prohibitions, and licensing requirements to guide shippers avoid penalties and delays.</li>
          <li className="text-sm"><strong>Ensuring compliance with customs codes and standards:</strong> We ensure that your shipments comply with all relevant customs codes, standards, and classifications, minimizing the risk of customs delays and penalties.</li>
        </ul>
      </div>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Advisory on Regulatory and Compliance for Trade Agreements:</h4>
      <p className="text-sm mb-6">
        Preferential Trade Agreements (PTAs) and Free Trade Agreements (FTAs) offer significant opportunities for businesses to reduce tariffs and non-tariff barriers, expand market access, and boost international trade. However, navigating the regulatory and compliance policies associated with trade agreements requires careful consideration and adherence to specific rules and procedures. Saharawinds is your trusted partner in understanding trade agreements compliance. Saharawinds Ltd team possesses in-depth knowledge of various FTAs and PTAs, and we will guide your business to explore compliance and qualify for the following trade agreements:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li className="text-sm">African Continental Free Trade Area (AfCFTA)</li>
        <li className="text-sm">African Growth and Opportunity Act (AGOA)</li>
        <li className="text-sm">Common Market for Eastern and Southern Africa (COMESA)</li>
        <li className="text-sm">East African Community (EAC) Customs Union</li>
        <li className="text-sm">East African Community - European Union (EAC-EU) Economic Partnership Agreement</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Key Regulatory and Compliance Considerations for Free Trade Agreements & Preferential Trade Agreements:</h4>
      <div className="space-y-4">
        <h5 className="text-sm font-semibold">1. Rules of Origin (ROO)</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm">Product Origin: Determine the origin of goods to qualify for preferential treatment. This often involves tracking the transformation of products and the percentage of value added within the FTA region.</li>
          <li className="text-sm">Certificate of Origin (COO): Prepare and submit accurate COOs, which certify that goods meet ROO requirements.</li>
          <li className="text-sm">Documentation: Maintain detailed records of production processes, materials, and supplier information to support COO claims.</li>
        </ul>

        <h5 className="text-sm font-semibold">2. Customs Clearance Procedures</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm">Tariff Classification: Ensure correct classification of goods to benefit from reduced tariffs.</li>
          <li className="text-sm">Customs Declarations: Complete accurate customs declarations, including information on product origin, value, and quantity.</li>
          <li className="text-sm">Import/Export Procedures: Adhere to specific import and export procedures, including customs formalities, inspections, and licensing requirements.</li>
        </ul>

        <h5 className="text-sm font-semibold">3. Sanitary and Phytosanitary protocols</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm">Food Safety and Animal Health: Comply with strict food safety and animal health standards, including labelling and certification requirements.</li>
          <li className="text-sm">Plant Health: Adhere to plant quarantine and phytosanitary regulations to prevent the spread of plant diseases and pests.</li>
        </ul>

        <h5 className="text-sm font-semibold">4. Technical Barriers to Trade</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm">Product Standards: Meet technical standards and regulations, including product testing, labelling, and certification.</li>
          <li className="text-sm">Conformity Assessment Procedures: Understand and follow the required conformity assessment procedures, such as product certification and testing.</li>
        </ul>

        <h5 className="text-sm font-semibold">5. Intellectual Property Rights (IPR)</h5>
        <ul className="list-disc pl-6 space-y-2">
          <li className="text-sm">Patent, Trademark, and Copyright Protection: Respect and protect intellectual property rights within the FTA region.</li>
          <li className="text-sm">Enforcement: Adhere to IPR enforcement mechanisms and procedures.</li>
        </ul>
      </div>
    </section>

    <section>
      <p className="text-sm mt-6">
        By carefully considering these regulatory and compliance factors, businesses can maximize the benefits of FTAs & PTAs to minimize the risks associated with non-compliance. Consult Saharawinds Ltd to learn more about how Saharawinds will support your business in maximizing the benefits of these trade agreements.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-6">Why Choose Saharawinds?</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li className="text-sm"><strong>Expert Team:</strong> Our experienced customs brokers possess in-depth knowledge of regulations and are dedicated to providing exceptional service.</li>
        <li className="text-sm"><strong>Global Network:</strong> We leverage our extensive partners to ensure smooth customs clearance worldwide.</li>
        <li className="text-sm"><strong>Efficiency & Cost-effectiveness:</strong> Saharawinds ensures compliance while helping clients minimize costs and avoid penalties.</li>
      </ul>
    </section>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

  </div>`,
    },
    {
      title: "Cold Chain Management",
      img: null,
      text: ` <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">Saharawinds Cold Chain Logistics</h3>
      <p className="text-sm mb-4">
        At Saharawinds Ltd, we specialize in offering door-to-door cool chain services. We manage the integrity of perishable shipments throughout the entire supply cool chain, ensuring quality and freshness from source to destination. Our services are perfect for shipments of cut flowers, fresh fruits, fresh vegetables, chilled & frozen meat, and seafood.
      </p>
      <p className="text-sm mb-4">
        Saharawinds offers state-of-the-art cool chain logistics solutions to preserve the quality and freshness of temperature-sensitive cargo. Our dedicated team and advanced facilities ensure that your perishable shipments are handled with the utmost care, from origin to delivery at the destination.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">Saharawinds Cool Chain Services</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li className="text-sm">Temperature-Controlled Warehousing: Saharawinds Ltd provides cold storage facilities equipped with temperature control systems to maintain optimal conditions for your perishable shipments, preventing spoilage and ensuring product integrity.</li>
        <li className="text-sm">Refrigerated Transportation: Saharawinds Ltd utilizes a fleet of refrigerated trucks and sea containers to ensure consistent temperature control during transportation, safeguarding the quality of fruits, cut flowers, vegetables, meat, and seafood shipments.</li>
        <li className="text-sm">Real-Time Monitoring: Saharawinds Ltd tracking systems allow monitoring of the temperature and humidity levels of shipments in real-time to ensure optimal conditions and enable proactive intervention when necessary.</li>
        <li className="text-sm">Customised Cold Chain Solutions: Saharawinds Ltd tailors its services to meet shippers' specific cool chain needs, whether it's a single perishable shipment or a complex cool supply chain. Saharawinds' team will work closely with shippers to develop a customized cold chain solution that meets the unique requirements.</li>
        <li className="text-sm">Experienced Cold Chain Experts: Saharawinds' team of cold chain experts has extensive experience in handling perishable cargo and understands the critical factors that impact cold chain optimization. The team is dedicated to ensuring the safe and timely transportation of perishable cargo such as cut flowers (roses, summer flowers), fresh fruits, fresh vegetables, chilled & frozen meat, and seafood.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">Additional Services</h4>
      <ul className="list-disc pl-6 space-y-2">
        <li className="text-sm">Product Inspection and Quality Control: Rigorous inspections to ensure product quality and compliance with phytosanitary and health standards.
          <ul className="ml-6 space-y-2">
            <li className="text-sm"><strong>Plant Health:</strong> Saharawinds will facilitate phytosanitary inspection and issue the phytosanitary certificate to ensure plant health and compliance with quarantine regulations.</li>
            <li className="text-sm"><strong>Food Safety and Animal Health:</strong> Saharawinds ensures meat and seafood shipments comply with food safety and animal health standards, including labeling and certification requirements.</li>
          </ul>
        </li>
        <li className="text-sm">Packaging and Labelling: Proper packaging and labelling to protect your products during transit.</li>
        <li className="text-sm">Customs Clearance for Perishable Shipments: Expert handling of perishable shipments through the customs examination & inspection process, document preparation, and declaration in compliance with export and import regulations. We facilitate pre-clearance to fast-track shipments at entry or exit border controls.</li>
        <li className="text-sm">Sourcing of Cut Flowers and Consolidation: We facilitate international florists to source cut flowers directly from farms in Kenya. Our consolidation services allow florists to combine shipments from multiple farms into a single consignment, saving on cost and complexity.</li>
      </ul>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">Why Choose Saharawinds Cold Chain Logistics?</h4>
      <div className="space-y-4">
        <div>
          <h5 className="text-sm font-semibold mb-2">Global Reach and Expertise</h5>
          <p className="text-sm">
            Saharawinds leverages a vast network of experienced partners to provide seamless cold chain solutions for perishable shipments. We manage shipments at both origin and destination in key international locations, ensuring end-to-end supply chain management with the highest standards of quality and efficiency.
          </p>
        </div>
        
        <div>
          <h5 className="text-sm font-semibold mb-2">Advanced Technology and Innovation</h5>
          <p className="text-sm">
            We invest in cold chain technology to optimize our supply chain and minimize risks. Our real-time tracking systems, temperature-controlled warehouses, and refrigerated transportation ensure the integrity of perishable shipments throughout the process.
          </p>
        </div>

        <div>
          <h5 className="text-sm font-semibold mb-2">Customer-Centric Approach</h5>
          <p className="text-sm">
            We prioritize our clients' needs and tailor solutions to meet their specific requirements. Our dedicated team works closely with shippers to understand their unique challenges and provide customized solutions.
          </p>
        </div>

        <div>
          <h5 className="text-sm font-semibold mb-2">Competitive Pricing and Cost-Effective Solutions</h5>
          <p className="text-sm">
            Saharawinds offers competitive pricing and cost-effective solutions without compromising quality. Our streamlined processes and efficient operations help shippers optimize supply chain costs and improve their bottom line.
          </p>
        </div>
      </div>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "Road and Railway Transport",
      img: null,
      text: `  <div className="p-6 space-y-6">
    <section>
      <h3 className="text-lg font-bold mb-4">Saharawinds Road and Railway Transport</h3>
      <p className="text-sm mb-4">
        Reliable Inland Transport Across Kenya and East Africa
      </p>
      <p className="text-sm mb-4">
        At Saharawinds, we offer comprehensive road and railway transport services to ensure your goods reach their final destinations efficiently across Kenya and the broader East Africa region. We prioritize timely delivery and secure handling for every shipment.
      </p>
    </section>

    <section>
      <h4 className="text-md font-semibold mb-4">Safety Measures During Transport</h4>
      <ul className="list-disc pl-6">
        <li className="text-sm">Secure Handling: All shipments are handled with care to prevent damage during transit.</li>
        <li className="text-sm">Real-Time Tracking: Our advanced tracking systems provide real-time updates on the location and status of your goods.</li>
        <li className="text-sm">Compliance with Regulations: Adherence to all local and international transport regulations to ensure the safety and legality of every shipment.</li>
      </ul>
    </section>

    <section>
      <p className="text-sm">
        <strong>Inquire Now</strong> to learn more about our reliable inland transport solutions.
      </p>
      <p className="text-base mt-4"><span className=" font-bold">Saharawinds ltd </span><i className="text-sm mb-4"> - Logistics Excellence</i></p>

    </section>
  </div>`,
    },
    {
      title: "",
      img: null,
      text: ``,
    },
  ];
  //   console.log(produce.filter((item) => item.selected));
  //   const [s, setS] = useState([]);
  //   const c = [
  //     "Avocado",
  //     "Mango",
  //     "Pineapple",
  //     "Banana",
  //     "Passion Fruit",
  //     "Custard Apple",
  //     "Coffee",
  //     "Ginger",
  //     "Flowers",
  //     "Veggies",
  //   ];

  //   useEffect(() => {
  //     if (service) {
  //     //   setS(service.filter((item) => item.selected));
  //       console.log(s);
  //     }
  //   }, [service]);
  return (
    <motion.div
      initial={{ x: "-100vw" }}
      animate={
        modal.state
          ? {
              x: 0,
              transition: { x: { duration: 0 } },
            }
          : { x: "-100vw", transition: { x: { duration: 0, delay: 0.8 } } }
      }
      className={`modal-container`}
    >
      <motion.div
        initial={{ x: "-100vw", y: 20, opacity: 0 }}
        animate={
          modal.state
            ? {
                x: 0,
                y: 0,
                opacity: 1,
                transition: {
                  x: { duration: 0 },
                  y: { duration: 0.3 },
                  opacity: { duration: 0.3 },
                },
              }
            : {
                x: "-100vw",
                y: 20,
                opacity: 0,
                transition: { x: { duration: 0, delay: 0.3 }, duration: 0.3 },
              }
        }
        style={{ justifyItems: "center" }}
        className={`modal lg:w-[calc(100%-8rem)] w-[calc(100%-4rem)]`}
      >
        <div
          onClick={() => setModal({ state: !modal.state, value: modal.value })}
          style={{ zIndex: 999999999999999 }}
          className="w-full"
        ></div>
        <div className=" form-container w-full relative  max-h-[90vh] overflow-scroll bg-[color:var(--brand-panel)]">
          <CancelRoundedIcon
            className="close"
            fontSize=""
            onClick={() => {
              setModal({ state: !modal.state, value: modal.value });
            }}
          />
          <h4 className="section-title black center text-[color:var(--brand-primary)]">
            {values.filter((i) => i.title === modal.value)[0]?.title}
          </h4>
          <br />
          <div className="about-s1 mx-[-1rem]">
            {parse(
              values.filter((i) => i.title === modal.value)[0]?.text || ""
            )}
          </div>
        </div>
      </motion.div>
      <motion.div
        initial={{ x: "-100vw", y: 0, opacity: 0 }}
        animate={
          modal.state
            ? {
                x: 0,
                y: 0,
                opacity: 1,
                transition: { x: { duration: 0 } },
              }
            : {
                x: "-100vw",
                y: 0,
                opacity: 0,
                transition: {
                  opacity: { delay: 0.3 },
                  x: { duration: 0, delay: 0.6 },
                },
              }
        }
        className={`modal-overlay`}
        onClick={() => setModal({ state: false, value: modal.value })}
      ></motion.div>
    </motion.div>
  );
};

export default Modal;
